import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getStreamWithUserData } from '../../../api/streams';
import { generateStreamCIDKey } from '../../../components/Streams/utils/generateStreamCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeStreamWithUserData } from '../../../utils/streams';

export const fetchStream = createAsyncThunk(
  `streams/fetchStream`,
  async (streamData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [streamResponse, streamUserDataResponse] =
        await getStreamWithUserData(streamData, {
          cancelToken: source.token,
        });
      return mergeStreamWithUserData(streamResponse, streamUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchStreamExtraReducers = builder => {
  builder
    .addCase(fetchStream.pending, (state, action) => {
      const streamCIDKey = generateStreamCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.streams.stream.request,
        action,
        streamCIDKey,
      );
    })
    .addCase(fetchStream.fulfilled, (state, action) => {
      const streamCIDKey = generateStreamCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.streams.stream.request[streamCIDKey],
        action,
        () => {
          state.streams.stream.byId[streamCIDKey] = action.payload;

          if (!state.streams.stream.allIds.includes(streamCIDKey)) {
            state.streams.stream.allIds.push(streamCIDKey);
          }
        },
      );
    })
    .addCase(fetchStream.rejected, (state, action) => {
      handleRequestRejection(
        state.streams.stream.request[
          generateStreamCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
